<template>
  <ui-component-modal
    :modalTitle="'Edit location utilization settings'"
    :isSaving="isSaving"
    :isSavingSuccess="isSavingSuccess"
    :isSavingError="isSavingError"
    :hideSaveButton="isSavingError || isSavingSuccess"
    :buttonLabelCancel="isSavingError || isSavingSuccess ? 'Close' : 'Cancel'"
    :onClickCancel="onClickCancel"
    :onClickSave="saveYieldSettings"
    :showModal="showModal"
    @closeModal="onClickCancel"
  >
    <template slot="modalTitle"></template>
    <template v-slot:content>
      <table
        v-if="mYieldSettings.ApplyLocationUtilization"
        class="table is-fullwidth"
      >
        <tbody>
          <tr v-if="mYieldSettings.ApplyLocationUtilization">
            <td width="100">0% utilization</td>
            <td>
              <vue-slider
                v-model="values"
                :min="0"
                :max="200"
                :enableCross="false"
                :interval="1"
                :tooltip-formatter="formatter"
              />
            </td>
            <td width="100">100% utilization</td>
          </tr>
        </tbody>
      </table>
    </template>
  </ui-component-modal>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import yieldProvider from '@/providers/yield'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

export default {
  components: {
    VueSlider,
  },

  props: {
    showModal: {
      type: Boolean,
      default: false,
    },

    onClickCancel: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      formatter: (v) => `${v - 100}%`,
      isSaving: false,
      isSavingSuccess: false,
      isSavingError: false,
      locationUtilizationCalculationTypes: [],
      locationUtilizationDefaultHours: [0, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      mYieldSettings: null,
      values: [],
    }
  },

  computed: {
    ...mapState('yieldStore', ['yieldSettingsState']),
  },

  created() {
    this.mYieldSettings = JSON.parse(
      JSON.stringify(this.yieldSettingsState.yieldSettings)
    )

    this.locationUtilizationCalculationTypes.push({
      id: 0,
      name: 'Based on fixed hours',
    })
    this.locationUtilizationCalculationTypes.push({
      id: 1,
      name: 'Based on actual openinghours',
    })

    this.values = this.locationValues()
  },

  methods: {
    ...mapMutations('yieldStore', ['setYieldSettingsState']),

    locationValues() {
      return [
        this.roundToZero(
          this.mYieldSettings.LocationUtilizationBottomValue * 100
        ),
        this.roundToZero(this.mYieldSettings.LocationUtilizationTopValue * 100),
      ]
    },

    saveYieldSettings() {
      let self = this
      self.isSaving = true

      let bottomValue = self.values[0] / 100
      let topValue = self.values[1] / 100

      self.mYieldSettings.LocationUtilizationBottomValue = bottomValue
      self.mYieldSettings.LocationUtilizationTopValue = topValue
      self.yieldSettingsState.yieldSettings = self.mYieldSettings

      yieldProvider.methods
        .updateLocationYieldSettings(self.mYieldSettings)
        .then((response) => {
          if (response.status === 204) {
            self.isSavingSuccess = true
            self.setYieldSettingsState(self.yieldSettingsState)

            setTimeout(() => {
              self.onClickCancel()
            }, 1500)
          }
        })
        .catch((error) => {
          self.isSavingError = true
        })
        .finally(() => {
          self.isSaving = false
        })
    },

    roundToZero(num) {
      let self = this
      return +(Math.round(self.roundToTwo(num) + 'e+0') + 'e-0')
    },

    roundToTwo(num) {
      return +(Math.round(num + 'e+2') + 'e-2')
    },
  },
}
</script>
